// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jMpNb","newExpiryDate":"styles_newExpiryDate__3G5TY","footer":"styles_footer__3QNhd"};